<template>
  <div>
    <CCard>
      <CCardBody class="profile-home">
        <div class="user-info-table" v-if="TopInfo">
          <dl class="row r-content px-2">
            <dd class="col-sm-12">
              <dl class="row sub-r-content">
                <dt class="col-sm-3">ユーザ名</dt>
                <dd class="col-sm-9">{{ user.name }}</dd>
                <dt class="col-sm-3">カードID</dt>
                <dd class="col-sm-9">{{ user.cardId }}</dd>
                <dt class="col-sm-3">氏名</dt>
                <dd class="col-sm-9">{{ fullName }}</dd>
                <dt class="col-sm-3">氏名（カナ）</dt>
                <dd class="col-sm-9">
                  {{ user.lastName }} {{ user.firstName }}
                </dd>
                <dt class="col-sm-3">性別</dt>
                <dd class="col-sm-9">{{ user.gender | genderString }}</dd>
                <dt class="col-sm-3">生年月日</dt>
                <dd class="col-sm-9" v-if="user.birth">
                  {{ user.birth | formateDate }}
                </dd>
                <dd class="col-sm-9" v-if="!user.birth"></dd>
                <dt class="col-sm-3">Eメール</dt>
                <dd class="col-sm-9">{{ user.email }}</dd>
                <dt class="col-sm-3">電話番号</dt>
                <dd class="col-sm-9">
                  {{ user.countryCode }} {{ user.mobile }}
                </dd>
                <dt class="col-sm-3">国</dt>
                <dd class="col-sm-9">{{ user.address.country.name }}</dd>
                <dt class="col-sm-3">郵便番号</dt>
                <dd class="col-sm-9">{{ user.address.zipCode }}</dd>
                <dt class="col-sm-3">都道府県</dt>
                <dd class="col-sm-9">{{ user.address.state }}</dd>
                <dt class="col-sm-3">市区町村</dt>
                <dd class="col-sm-9">{{ user.address.city }}</dd>
                <dt class="col-sm-3">地番番地</dt>
                <dd class="col-sm-9">{{ user.address.address1 }}</dd>
                <dt class="col-sm-3">建物・その他</dt>
                <dd class="col-sm-9">{{ user.address.address2 }}</dd>
              </dl>
            </dd>
          </dl>
          <CButton class="info-button p-center" @click="openEditDialog()">
            <i class="icon cil-pencil"></i> 編集</CButton
          >
        </div>
        <!-- TopInfo end  -->
        <div class="edit-info-app" v-if="editingModal">
          <CForm class="member-info modal-form">
            <CRow>
              <CCol>
                <div class="form-group form-row">
                  <label class="col-form-label col-sm-3">氏</label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      v-model="itemToEdit.familyName"
                      v-on:input="familyName_furigana"
                    />
                  </div>
                </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.familyName.required"
                >
                  氏の入力は必須です
                </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.familyName.maxLength"
                >
                  氏は{{
                    limited.familyName.maxLength
                  }}文字以下で入力してください
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <CInput
                  label="氏（カナ）"
                  horizontal
                  required
                  v-model="itemToEdit.firstName"
                />
                                  <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.firstName.$dirty &&
                      !$v.itemToEdit.firstName.required
                    "
                  >
                    氏（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.firstName.isKana"
                  >
                    氏（カナ）はカタカナを入力してください
                  </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <div class="form-group form-row">
                  <label class="col-form-label col-sm-3">名</label>
                  <div class="col-sm-9">
                    <input
                      type="text"
                      class="form-control"
                      v-model="itemToEdit.givenName"
                      v-on:input="givenName_furigana"
                    />
                  </div>
                </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.givenName.required"
                >
                  名の入力は必須です
                </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.givenName.maxLength"
                >
                  名は{{
                    limited.givenName.maxLength
                  }}文字以下で入力してください
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CInput
                  label="名（カナ）"
                  horizontal
                  required
                  v-model="itemToEdit.lastName"
                />
               <div
                    class="text-danger input-info"
                    v-if="
                      $v.itemToEdit.lastName.$dirty &&
                      !$v.itemToEdit.lastName.required
                    "
                  >
                    名（カナ）の入力は必須です
                  </div>
                  <div
                    class="text-danger input-info"
                    v-if="!$v.itemToEdit.lastName.isKana"
                  >
                    名（カナ）はカタカナを入力してください
                  </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.lastName.maxLength"
                >
                  名（カナ）は{{
                    limited.lastName.maxLength
                  }}文字以下で入力してください
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <CSelect
                  label="性別"
                  horizontal
                  :options="options.genderOptions"
                  :value.sync="itemToEdit.gender"
                />
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.gender.required"
                >
                  性別の選択は必須です
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CInput
                  label="生年月日"
                  type="date"
                  horizontal
                  required
                  v-model="itemToEdit.birth"
                />
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.birth.required"
                >
                  生年月日の入力は必須です
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <CInput
                  label="Eメール"
                  horizontal
                  plaintext
                  required
                  v-model="itemToEdit.email"
                />
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <CSelect
                  label="国番号"
                  horizontal
                  :options="codeOptions"
                  :value.sync="itemToEdit.countryCode"
                >
                  {{ itemToEdit.countryCode }}
                </CSelect>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CInput
                  label="電話番号"
                  description="ハイフン(-)は入力しないでください"
                  horizontal
                  required
                  v-model="itemToEdit.mobile"
                />
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.mobile.required"
                >
                  電話番号の入力は必須です
                </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.mobile.numeric"
                >
                  電話番号は数値を入力してください
                </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.mobile.maxLength"
                >
                  電話番号は{{
                    limited.mobile.maxLength
                  }}文字以下で入力してください
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol>
                <CSelect
                  label="国"
                  horizontal
                  :options="countryOptions"
                  :value.sync="itemToEdit.address.country.id"
                />
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.address.country.required"
                >
                  国の選択は必須です
                </div>
              </CCol>
            </CRow>

            <CRow>
              <CCol class="w-75">
                <CInput
                  label="郵便番号"
                  horizontal
                  required
                  v-model="itemToEdit.address.zipCode"
                />
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.address.zipCode.required"
                >
                  郵便番号の入力は必須です
                </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.address.zipCode.maxLength"
                >
                  郵便番号は{{
                    limited.address.zipCode.maxLength
                  }}文字以下で入力してください
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <div class="form-group form-row">
                  <label class="col-sm-3"></label>
                  <div class="col-sm-9">
                    <CButton color="success" @click="getAddress()"
                      ><i class="icon cil-location-pin"></i>
                      住所自動入力</CButton
                    >
                  </div>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CInput
                  label="都道府県"
                  horizontal
                  required
                  v-model="itemToEdit.address.state"
                />
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.address.state.required"
                >
                  都道府県の入力は必須です
                </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.address.state.maxLength"
                >
                  都道府県は{{
                    limited.address.state.maxLength
                  }}文字以下で入力してください
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CInput
                  label="市区町村"
                  horizontal
                  required
                  v-model="itemToEdit.address.city"
                />
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.address.city.required"
                >
                  市区町村の入力は必須です
                </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.address.city.maxLength"
                >
                  市区町村は{{
                    limited.address.city.maxLength
                  }}文字以下で入力してください
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CInput
                  label="地番番地"
                  horizontal
                  required
                  v-model="itemToEdit.address.address1"
                />
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.address.address1.required"
                >
                  地番番地の入力は必須です
                </div>
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.address.address1.maxLength"
                >
                  地番番地は{{
                    limited.address.address1.maxLength
                  }}文字以下で入力してください
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <CInput
                  label="建物・その他"
                  horizontal
                  required
                  v-model="itemToEdit.address.address2"
                />
                <div
                  class="text-danger input-info"
                  v-if="!$v.itemToEdit.address.address2.maxLength"
                >
                  建物・その他は{{
                    limited.address.address2.maxLength
                  }}文字以下で入力してください
                </div>
              </CCol>
            </CRow>
          </CForm>
          <CRow class="mt-4">
            <CCol>
              <CButton
                class="px-4 float-left"
                @click="cancelEditProfile()"
                color="secondary"
                ><i class="icon cil-arrow-left"></i> 戻る</CButton
              >

              <CButton
                class="float-right px-4"
                @click="saveProfile()"
                color="success"
                :disabled="$v.itemToEdit.$invalid"
                ><i class="icon cil-save"></i> 保存</CButton
              >
            </CCol>
          </CRow>
        </div>
        <!-- edit-info-app end  -->
        <!-- <div class="success-modal" v-if="successModal">
          更新が完了しました。
        </div> -->

        <div v-if="successModal">
          <CAlert color="success"> 更新が完了しました。 </CAlert>
          <CButton
            class="p-center"
            onclick="window.location.reload();"
            color="success"
            ><i class="icon cil-arrow-left"></i> 戻る</CButton
          >
        </div>
      </CCardBody>
    </CCard>

    <CModal
      color="danger"
      closeOnBackdrop
      :centered="true"
      :show.sync="errorModal"
    >
      <p>{{ errorMessage }}</p>
      <template #header>
        <h4 class="modal-title">Error</h4>
      </template>
      <template #footer>
        <CButton @click="errorModal = false" color="secondary">
          <i class="icon cil-x"></i> 閉じる
        </CButton>
      </template>
    </CModal>
     
  </div>
</template>

<script>
// import Vue from 'vue'
import axios from "axios";
import {
  required,
  maxLength,
  numeric,
  helpers,
} from "vuelidate/lib/validators";
import FamilyMember from "../../components/FamilyMember";
import Options from "../../components/Options";

import historykana from "historykana";
import * as wanakana from "wanakana";

const avatar_url =
  "https://gaa9xd7j0g.execute-api.ap-northeast-1.amazonaws.com/develop";
const zipcode_url =
  "https://jxamy7mdqg.execute-api.ap-northeast-1.amazonaws.com/api/";

const limited = {
  familyName: { maxLength: 100 },
  givenName: { maxLength: 100 },
  firstName: { maxLength: 100 },
  lastName: { maxLength: 100 },
  mobile: { maxLength: 20 },
  address: {
    zipCode: { maxLength: 10 },
    state: { maxLength: 255 },
    city: { maxLength: 255 },
    address1: { maxLength: 255 },
    address2: { maxLength: 255 },
  },
};

export default {
  components: {
    // FamilyMember,
  },
  name: "Profile",
  data() {
    return {
       
      furigana: "",
      newEmail: "",
      history: [],
      ModalTitle: "",
      errorMessage: "",
      TopInfo: true,
      editingModal: false,
      ConfirmModal: false,
      successModal: false,
      errorModal: false,
      withdrawalModal: false,
      withdrawalAgree: false,
      withdrawalConfirmModal: false,
      withdrawalCompleteModal: false,
      engFirstName: true,
      engLastName: true,
      codeOptions: [],
      countryOptions: [],
      options: Options.data(),
      user: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        gender: "",
        birth: "",
        userName: "",
        cardId: "",
        email: "",
        emailVerified: true,
        countryCode: "",
        mobile: "",
        address: {
          state: "",
          city: "",
          address1: "",
          address2: "",
          zipCode: "",
          country: {
            id: "",
            name: "",
            fullName: "",
            alpha2: "",
            alpha3: "",
            dial: "",
            flagData: "",
          },
        },
        picture: "",
      },
      itemToEdit: {
        firstName: "",
        lastName: "",
        familyName: "",
        givenName: "",
        gender: "",
        birth: "",
        userName: "",
        countryCode: "",
        mobile: "",
        address: {
          state: "",
          city: "",
          address1: "",
          address2: "",
          zipCode: "",
          country: {
            id: "",
            name: "",
            fullName: "",
            alpha2: "",
            alpha3: "",
            dial: "",
            flagData: "",
          },
        },
        picture: "",
      },
      avatar: {
        image: "",
        previewImage: "",
        type: "",
      },
      limited: limited,
    };
  },
  validations() {
    const isKana = helpers.regex("isKana", /^([ァ-ヴ][ァ-ヴー・]*)$/);

    return {
      withdrawalModal: {
        required: { allowFalse: false },
      },
      itemToEdit: {
        familyName: {
          required,
          maxLength: maxLength(limited.familyName.maxLength),
        },
        givenName: {
          required,
          maxLength: maxLength(limited.givenName.maxLength),
        },
        firstName: {
          required,
          isKana: this.engFirstName ? false : isKana,
          maxLength: maxLength(limited.firstName.maxLength),
        },
        lastName: {
          required,
          isKana: this.engLastName ? false : isKana,
          maxLength: maxLength(limited.lastName.maxLength),
        },
        gender: { required },
        birth: { required },
        mobile: {
          required,
          numeric,
          maxLength: maxLength(limited.mobile.maxLength),
        },
        address: {
          country: { required },
          zipCode: {
            required,
            maxLength: maxLength(limited.address.zipCode.maxLength),
          }, // Note: US9桁
          state: {
            required,
            maxLength: maxLength(limited.address.state.maxLength),
          },
          city: {
            required,
            maxLength: maxLength(limited.address.city.maxLength),
          },
          address1: {
            required,
            maxLength: maxLength(limited.address.address1.maxLength),
          },
          address2: {
            maxLength: maxLength(limited.address.address2.maxLength),
          },
        },
      },
      newEmail: { required, maxLength: maxLength(100) },
    };
  },
  filters: {
    genderString: function (value) {
      if (!value) return "公開しない";
      var retString;
      switch (value) {
        case "UNKONWN":
          retString = "公開しない";
          break;
        case "MALE":
          retString = "男性";
          break;
        case "FEMALE":
          retString = "女性";
          break;
        default:
          retString = "未知";
          break;
      }
      return retString;
    },
    emailVerifiedString: function (value) {
      if (!value) return "不明";
      switch (value) {
        case true:
          return "承認済み";
        case false:
          return "未承認";
        default:
          return "不明";
      }
    },
  },

  methods: {
    getUserInformation: function () {

    //Login as registered user
      var urlRequest = "/rest/currentuser";
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          this.user = resp.data;
          console.log("User Data:" + JSON.stringify(this.user));
          FamilyMember.methods.setFullName(this.fullName);
          // this.downloadAvatar();
        })
        .catch((err) => {
           

          console.log(err);
        });
    },
    getCountries: function () {
      //Login as registered user
      var urlRequest = "/rest/country";
      axios
        .get(urlRequest, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("getCountries:" + JSON.stringify(resp.data));

          this.countryOptions = [];
          this.codeOptions = [];
          resp.data.forEach((element) => {
            this.countryOptions.push({
              value: element.id,
              label: element.name,
            });
            // 国際電話の国番号をセット
            this.codeOptions.push({
              value: element.dial,
              label: element.name + " (" + element.dial + ")",
            });
          });
        })
        .catch((err) => {
           

          console.log(err);
        });
    },
    openEditDialog() {
      this.resetProfile();
      this.getCountries();
      this.TopInfo = false;
      this.editingModal = true;
    },
    saveProfile: async function () {
      // 更新があればプロフィール画像登録を行う
      if (this.avatar.type != "") await this.uploadAvatar();

      const urlRequest = "/rest/users/" + this.$keycloak.userName;

      console.log("Request Data:" + JSON.stringify(this.itemToEdit));
      axios
        .put(urlRequest, this.itemToEdit, {
          headers: { Authorization: `Bearer ${this.$keycloak.token}` },
        })
        .then((resp) => {
          console.log("User profile updated:" + resp.data);
          this.editingModal = false;
          this.TopInfo = false;
          this.getUserInformation();
          this.successModal = true;
        })
        .catch((err) => {
           

          console.log("Updating profile error: " + err);
          this.errors = err;
          this.errorModal = true;
        });
    },
    // get date information
    getDateString: function (dateItem) {
      var today;
      if (dateItem) {
        today = new Date(dateItem);
      } else {
        today = new Date();
      }

      var dateString =
        today.getFullYear() +
        "-" +
        (today.getMonth() + 1) +
        "-" +
        today.getDate();
      return dateString;
    },

    onAvatarChange: function (e) {
      // CInputFile の場合
      const files = e;

      this.avatar.type = files[0].type;
      console.log("this.avatar.type: " + this.avatar.type);

      this.getBase64(files[0])
        .then((avatar) => (this.avatar.previewImage = avatar))
        .catch((error) =>
          this.setError(error, "画像のアップロードに失敗しました。")
        );
    },
    getBase64: function (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    getAddress: function () {
      // Get address by zipcode
      const urlRequest =
        zipcode_url + "?postcode=" + this.itemToEdit.address.zipCode;

      axios
        .get(urlRequest)
        .then((resp) => {
          console.log("resp.data: ", resp.data);
          this.itemToEdit.address.state = resp.data.PrefecturesName;
          this.itemToEdit.address.city =
            resp.data.CityName + resp.data.TownName;
        })
        .catch((err) => {
           
          console.log(err);
        });
    },
    cancelEditProfile: function () {
      // 会員情報編集画面を閉じる
      this.resetProfile();
      this.editingModal = false;
      this.TopInfo = true;
    },
    resetProfile: function () {
      // 入力内容をリセット
      // note: Object.assign() は itemToEdit が user の参照になってしまうため却下
      //   例) this.itemToEdit = Object.assign({}, this.user);
      // note: スプレッド構文は、ネストしたオブジェクトが参照になるため却下
      //   例）this.itemToEdit = { ...this.user };
      //
      this.itemToEdit = JSON.parse(JSON.stringify(this.user));

      this.avatar.previewImage = this.avatar.image;
      this.avatar.type = "";
    },
    uploadAvatar: async function () {
      const urlRequest = avatar_url;
      const header = { headers: { ContentType: this.avatar.type } };
      // todo: ここでリサイズ処理が必要（100x100など）
      // todo-memo: 2020/09/25時点で resize-base64(動かない), sharp(node v12は動かない?), canvas(よくわからない)
      const original = this.avatar.previewImage.replace(
        /^data:\w+\/\w+;base64,/,
        ""
      );

      await axios
        .put(urlRequest, original, header)
        .then((resp) => {
          console.log("uploadAvatar:");
          console.log(resp.data);
          this.itemToEdit.picture = resp.data.key;
        })
        .catch((err) => {
           

          console.log("Upload avatar error: " + err);
          this.errors = err;
        });
    },
    downloadAvatar: function () {
      const key = this.user.picture;
      const urlRequest = avatar_url + "?key=" + key;
      const type = String(key).slice(".")[1]; // 拡張子を取得

      axios
        .get(urlRequest)
        .then((resp) => {
          console.log(resp);
          this.avatar.image = "data:image/" + type + ";base64," + resp.data;
          this.avatar.previewImage = this.avatar.image;
        })
        .catch((err) => {
           

          console.log("Download avatar error: " + err);
          this.errors = err;
        });
    },

    // TODO: 仕様確認
    /**
     * カードID編集ボタンクリック
     */
    onCardIdEditClick() {
      this.editCardIdModal = true;
    },
    requiredM() {
      this.$v.newEmail.$touch();
    },
    familyName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.firstName = input.target.value;
        this.engFirstName = true;
      } else {
        this.engFirstName = false;
        this.history.push(input.target.value);
        this.itemToEdit.firstName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
    givenName_furigana(input) {
      if (wanakana.isRomaji(input.target.value)) {
        this.itemToEdit.lastName = input.target.value;
        this.engLastName = true;
      } else {
        this.engLastName = false;
        this.history.push(input.target.value);
        this.itemToEdit.lastName = wanakana.toKatakana(
          historykana(this.history)
        );
      }
    },
  },
  beforeMount() {
    this.getUserInformation();
  },
  computed: {
    fullName() {
      return this.user.familyName + " " + this.user.givenName;
    },
  },
};
</script>
<style lang="scss">
.sp_card {
  border: none;
}
.card {
  border: none;
  .card-body {
    .alert {
      font-size: 0.85rem;
    }
    .form-row {
      margin: 0 0 1rem;
    }
    .col-sm-3 {
      width: 30%;
    }
    .col-sm-9 {
      width: 70%;
      padding-left: 2%;
    }
    .form-row {
      margin: 0;
    }
    .text-danger {
      padding-left: 32%;
    }
  }
}
.p-center {
  margin: 0 auto;
  display: table;
}
.btn {
  min-width: 45%;
}
</style>
